// Define a function to initialize the rating functionality
export const initRateRecipe = () => {
  const recipePage = document.querySelector(".recipe-page");

  if (recipePage) {
    // Check if star is clicked to turn of mouseleave for animation on stars.
    let starClicked = false;

    // Get the nodeId from the container's id
    const container = document.querySelector('.recipe-page') as HTMLElement;
    const nodeId = container.getAttribute('id');
    const ratingSections = document.querySelectorAll('.rating-section');

    // Check if the user has already rated this recipe in localStorage
    const hasRated = localStorage.getItem(`rated_recipe_${nodeId}`);
    if (hasRated) {
      // User has already rated, do not allow rating again
      ratingSections.forEach(section => {
        const ulElement = section.querySelector(".rating-list");
        if (ulElement) {
          ulElement.classList.add("rated");
        }
        const titleElement = section.querySelector(".rating-title");
        if (titleElement) {
          titleElement.textContent = "Ditt betyg";
        }
      });
    }

      // Initialize the rating button
      const ratingButtons = Array.from(document.querySelectorAll('.rating-button')) as HTMLButtonElement[];

      ratingButtons.forEach(ratingButton => {
          
          ratingButton.style.display = 'none';
      
    

      let selectedRating: string | null = null;

      // Attach a click event listener to each star element
      const starElements = document.querySelectorAll('.star');
      starElements.forEach(star => {
          star.addEventListener('click', (event: MouseEvent) => {
              // Continue with the rating process
              const starElement = event.target as HTMLElement;
              selectedRating = starElement.getAttribute('data-rating');

              // Highlight the selected rating and show filled stars up to the selected rating
              starElements.forEach(s => {
                  const sRating = s.getAttribute('data-rating');
                  if (sRating) {
                      const fillStar = parseInt(sRating, 10) <= parseInt(selectedRating || '0', 10);
                      s.classList.toggle('selected', sRating === selectedRating);
                      s.classList.toggle('filled', fillStar);
                  }
              });

              // Show the rating button after selecting a rating
              ratingButton.style.display = 'block';
          });
      });

      // Attach a click event listener to the rating button
      ratingButton.addEventListener('click', () => {
          if (selectedRating) {
              // Continue with the rating process
              let starClicked = true;

              // Rest of the existing code...
              localStorage.setItem(`rated_recipe_${nodeId}`, selectedRating);

              const url = `/umbraco/api/rate?userRating=${selectedRating}&nodeId=${nodeId}`;

              fetch(url, {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                  },
              })
                  .then(data => {
                      // Handle the response from your controller
                      console.log(data);
                  })
                  .catch(error => {
                      // Handle any errors
                      console.error(error);
                  });

              // Update other elements after submitting the rating
              updateUIAfterRating();
          }
      });

      // Function to update other UI elements after submitting the rating
      const updateUIAfterRating = () => {
          // Update other UI elements as needed
          ratingSections.forEach(section => {
              const ulElement = section.querySelector(".rating-list");
              if (ulElement) {
                  ulElement.classList.add("rated");
              }
              const titleElement = section.querySelector(".rating-title");
              if (titleElement) {
                  titleElement.textContent = "Ditt betyg";
              }
          });

          // Hide the rating button after submitting the rating
          ratingButton.style.display = 'none';
      };

      })




    // Function to fill stars up to the specified rating
    const fillStars = (rating: number, element: any) => {
      const starElements = element.querySelectorAll('.star');
      starElements.forEach((star: any, index: number) => {
        if (index < rating) {
          star.classList.add('star--filled');
        }
      });
    };

    // Hover functionality for places where rating is possible.
    const ratingContainers: NodeListOf<HTMLElement> = document.querySelectorAll(".rating--possible");

    ratingContainers.forEach((container: HTMLElement) => {
      const stars: NodeListOf<HTMLElement> | null = container.querySelectorAll(".star");

      if (stars) {
        stars.forEach((star: HTMLElement, index: number) => {
          star.addEventListener("mouseenter", () => {
            stars.forEach((s: HTMLElement, i: number) => {
              if (i <= index) {
                s.classList.add("star--filled");
              } else {
                s.classList.remove("star--filled");
              }
            });
          });

          // This code will run only when you leave the area and haven't clicked a star
          star.addEventListener("mouseleave", () => {
            if (!starClicked) {
              stars.forEach((s: HTMLElement) => s.classList.remove("star--filled"));
            }
          });
        });
      }
    });

    ratingSections.forEach(section => {
      // Check if a rating is stored in localStorage and fill the stars
      const storedRating = localStorage.getItem(`rated_recipe_${nodeId}`);
      if (storedRating) {
        fillStars(parseInt(storedRating, 10), section);
      }
    });
  }
};

// ...
//export const initRateRecipe = () => {
//    const recipePage = document.querySelector(".recipe-page");

//    if (recipePage) {
//        let starClicked = false;
//        let ratingConfirmed = false;
//        let currentRating = 0;

//        const container = document.querySelector('.recipe-page') as HTMLElement;
//        const nodeId = container.getAttribute('id');
//        const ratingSections: NodeListOf<HTMLElement> = document.querySelectorAll('.rating-section');

//        const hasRated = localStorage.getItem(`rated_recipe_${nodeId}`);
//        if (hasRated && !ratingConfirmed) {
//            // Anv�ndaren har inte bekr�ftat �nnu, fyll stj�rnorna fr�n localStorage
//            currentRating = parseInt(hasRated, 10);
//            fillStars(currentRating, ratingSections);
//        }

//        const starElements = document.querySelectorAll('.star');
//        starElements.forEach(star => {
//            star.addEventListener('click', (event) => {
//                starClicked = true;
//                const starElement = event.target as HTMLElement;
//                currentRating = parseInt(starElement.getAttribute('data-rating') || "0", 10);
//                localStorage.setItem(`rated_recipe_${nodeId}`, currentRating.toString());

//                const ratingButton = document.querySelector('.rating-button') as HTMLElement;
//                ratingButton.style.display = 'inline';

//                const ratingSections = document.querySelectorAll('.rating-section');

//                function isHTMLElement(element: Element): element is HTMLElement {
//                    return element instanceof HTMLElement;
//                }

//                ratingSections.forEach(section => {
//                    if (isHTMLElement(section)) {
//                        fillStars(currentRating, section as any);

//                        const ulElement = section.querySelector(".rating-list");
//                        if (ulElement) {
//                            ulElement.classList.add("rated");
//                        }

//                        const titleElement = section.querySelector(".rating-title");
//                        if (titleElement) {
//                            titleElement.textContent = "Ditt betyg";
//                        }
//                    }
//                });
//            });
//        });

//        const ratingButton = document.querySelector('.rating-button') as HTMLElement;
//        ratingButton.addEventListener('click', () => {
//            if (!ratingConfirmed) {
//                ratingConfirmed = true;

//                // Skicka betyget efter bekr�ftelse
//                const url = `/umbraco/api/rate?userRating=${currentRating}&nodeId=${nodeId}`;
//                fetch(url, {
//                    method: 'POST',
//                    headers: {
//                        'Content-Type': 'application/json',
//                    },
//                })
//                    .then(data => {
//                        console.log(data);
//                    })
//                    .catch(error => {
//                        console.error(error);
//                    });

//                ratingButton.style.display = 'none';

//                // Spara informationen om bekr�ftat betyg i localStorage
//                localStorage.setItem(`rating_confirmed_${nodeId}`, 'true');
//                localStorage.removeItem(`rated_recipe_${nodeId}`);

//                // Update the UI after voting
//                ratingSections.forEach(section => {
//                    const isHTMLElement = (element: Element): element is HTMLElement => {
//                        return element instanceof HTMLElement;
//                    };
//                    if (isHTMLElement(section)) {
//                        fillStars(currentRating, section as any);

//                        const ulElement = section.querySelector(".rating-list");
//                        if (ulElement) {
//                            ulElement.classList.add("rated");
//                        }

//                        const titleElement = section.querySelector(".rating-title");
//                        if (titleElement) {
//                            titleElement.textContent = "Ditt betyg";
//                        }
//                    }
//                });
//            }
//        });

//        const ratingContainers: NodeListOf<HTMLElement> = document.querySelectorAll(".rating--possible");

//        ratingContainers.forEach((container: HTMLElement) => {
//            const stars: NodeListOf<HTMLElement> | null = container.querySelectorAll(".star");

//            if (stars) {
//                stars.forEach((star: HTMLElement, index: number) => {
//                    star.addEventListener("mouseenter", () => {
//                        stars.forEach((s: HTMLElement, i: number) => {
//                            if (i <= index) {
//                                s.classList.add("star--filled");
//                            } else {
//                                s.classList.remove("star--filled");
//                            }
//                        });
//                    });

//                    star.addEventListener("mouseleave", () => {
//                        if (!starClicked) {
//                            stars.forEach((s: HTMLElement) => s.classList.remove("star--filled"));
//                        }
//                    });
//                });
//            }
//        });
//    }
//};

//const fillStars = (rating: number, sections: NodeListOf<HTMLElement>) => {
//    sections.forEach((section: HTMLElement) => {
//        const starElements = section.querySelectorAll('.star');
//        starElements.forEach((star: HTMLElement, index: number) => {
//            if (index < rating) {
//                star.classList.add('star--filled');
//            } else {
//                star.classList.remove('star--filled');
//            }
//        });
//    });
//};



//// Define a function to initialize the rating functionality
//export const initRateRecipe = () => {
//    const recipePage = document.querySelector(".recipe-page");
//    const ratingButton = document.querySelector('.rating-button') as HTMLElement;

//    if (recipePage) {
//        // Check if star is clicked to turn off mouseleave for animation on stars.
//        let starClicked = false;
//        let selectedRating: string | null = null;

//        // Get the nodeId from the container's id
//        const container = document.querySelector('.recipe-page') as HTMLElement;
//        const nodeId = container.getAttribute('id');
//        const ratingSections = document.querySelectorAll('.rating-section');

//        // Check if the user has already rated this recipe in localStorage
//        const hasRated = localStorage.getItem(`rated_recipe_${nodeId}`);
//        if (hasRated) {
//            // User has already rated, do not allow rating again
//            disableStarClick();
//            ratingSections.forEach(section => {
//                const ulElement = section.querySelector(".rating-list");
//                if (ulElement) {
//                    ulElement.classList.add("rated");
//                }
//                const titleElement = section.querySelector(".rating-title");
//                if (titleElement) {
//                    titleElement.textContent = "Ditt betyg";
//                }
//            });
//        }

//        // Attach a click event listener to each star element
//        const starElements = document.querySelectorAll('.star');
//        starElements.forEach(star => {
//            star.addEventListener('click', (event) => {
//                if (!starClicked) {
//                    starClicked = true;

//                    // Cast event.target to HTMLElement to access getAttribute
//                    const starElement = event.target as HTMLElement;

//                    // Get the data-rating attribute value
//                    selectedRating = starElement.getAttribute('data-rating');

//                    // Store the rating in localStorage and set the flag
//                    localStorage.setItem(`rated_recipe_${nodeId}`, selectedRating);

//                    // Fill the stars up to the rating
//                    ratingSections.forEach(section => {
//                        fillStars(parseInt(selectedRating!, 10), section);

//                        const ulElement = section.querySelector(".rating-list");
//                        if (ulElement) {
//                            ulElement.classList.add("rated");
//                        }
//                        const titleElement = section.querySelector(".rating-title");
//                        if (titleElement) {
//                            titleElement.textContent = "Ditt betyg";
//                        }
//                    });

//                    // Show the rating button
//                    ratingButton.style.display = 'block';
//                }
//            });
//        });

//        // Click event listener for the rating button
//        ratingButton.addEventListener('click', () => {
//            // Reset the starClicked flag
//            starClicked = false;

//            if (selectedRating) {
//                // Send the POST request only if a rating is selected
//                const url = `/umbraco/api/rate?userRating=${selectedRating}&nodeId=${nodeId}`;
//                fetch(url, {
//                    method: 'POST',
//                    headers: {
//                        'Content-Type': 'application/json',
//                    },
//                })
//                    .then(data => {
//                        // Handle the response from your controller
//                        console.log(data);
//                    })
//                    .catch(error => {
//                        // Handle any errors
//                        console.error(error);
//                    });
//            }

//            // Hide the rating button
//            ratingButton.style.display = 'none';

//            // You can add additional logic here for final approval if needed

//            // For demonstration purposes, you can clear the stored rating
//            const storedRating = localStorage.getItem(`rated_recipe_${nodeId}`);
//            if (storedRating) {
//                // Update the UI to reflect the approved rating
//                ratingSections.forEach(section => {
//                    fillStars(parseInt(storedRating, 10), section);

//                    const ulElement = section.querySelector(".rating-list");
//                    if (ulElement) {
//                        ulElement.classList.add("rated");
//                    }
//                    const titleElement = section.querySelector(".rating-title");
//                    if (titleElement) {
//                        titleElement.textContent = "Ditt betyg";
//                    }
//                });

//                // You can also send another request to update the server if needed
//                const url = `/umbraco/api/approveRating?userRating=${storedRating}&nodeId=${nodeId}`;
//                fetch(url, {
//                    method: 'POST',
//                    headers: {
//                        'Content-Type': 'application/json',
//                    },
//                })
//                    .then(data => {
//                        // Handle the response from your controller
//                        console.log(data);
//                    })
//                    .catch(error => {
//                        // Handle any errors
//                        console.error(error);
//                    });
//            }

//            // Disable star click after the button is pressed
//            disableStarClick();
//        });

//        // Function to fill stars up to the specified rating
//        const fillStars = (rating: number, element: any) => {
//            const starElements = element.querySelectorAll('.star');
//            starElements.forEach((star: any, index: number) => {
//                if (index < rating) {
//                    star.classList.add('star--filled');
//                }
//            });
//        };

//        // Hover functionality for places where rating is possible.
//        const ratingContainers: NodeListOf<HTMLElement> = document.querySelectorAll(".rating--possible");

//        ratingContainers.forEach((container: HTMLElement) => {
//            const stars: NodeListOf<HTMLElement> | null = container.querySelectorAll(".star");

//            if (stars) {
//                stars.forEach((star: HTMLElement, index: number) => {
//                    star.addEventListener("mouseenter", () => {
//                        stars.forEach((s: HTMLElement, i: number) => {
//                            if (i <= index) {
//                                s.classList.add("star--filled");
//                            } else {
//                                s.classList.remove("star--filled");
//                            }
//                        });
//                    });

//                    // This code will run only when you leave the area and haven't clicked a star
//                    star.addEventListener("mouseleave", () => {
//                        if (!starClicked) {
//                            stars.forEach((s: HTMLElement) => s.classList.remove("star--filled"));
//                        }
//                    });
//                });
//            }
//        });

        
//        // Function to disable star click
//        function disableStarClick() {
//            starElements.forEach(star => {
//                const starElement = star as HTMLElement;
//                starElement.removeEventListener('click', starClickHandler);
//                starElement.style.pointerEvents = 'none';
//            });
//        }

//        // Click event handler for stars after the button is pressed
//        function starClickHandler(event: Event) {
//            event.preventDefault();
//            // Optionally, you can show a message to the user that they can't change their vote after pressing the button
//        }
//    }
//};

        

